import { client } from '../../../services/apiClient';
import type {
  AiVisibilityReportsPageResponse,
  AiVisibilityReportRunsResponse,
  AiVisibilityReportUsageResponse,
  EnqueueAiVisibilityReportResult,
  GenerateAiVisibilityReportRequest,
} from '@brand24-original/llm-types';

const ENDPOINT = '/ai-visibility-report';

/** Account-scoped (quota is shared by all projects) — hence no projectId in the path. */
export const getAiVisibilityUsage = async (): Promise<AiVisibilityReportUsageResponse> => {
  const { data } = await client(true, true).get<AiVisibilityReportUsageResponse>(
    `${ENDPOINT}/usage`
  );
  return data;
};

export const getAiVisibilityRuns = async (
  projectId: number
): Promise<AiVisibilityReportRunsResponse> => {
  const { data } = await client(true, true).get<AiVisibilityReportRunsResponse>(
    `${ENDPOINT}/${projectId}/runs`
  );
  return data;
};

export const getAiVisibilityReports = async (
  projectId: number,
  page: number,
  pageSize: number
): Promise<AiVisibilityReportsPageResponse> => {
  const { data } = await client(true, true).get<AiVisibilityReportsPageResponse>(
    `${ENDPOINT}/${projectId}/reports`,
    { params: { page, pageSize } }
  );
  return data;
};

export const generateAiVisibilityReport = async (
  projectId: number,
  from: string,
  to: string
): Promise<EnqueueAiVisibilityReportResult> => {
  const body: GenerateAiVisibilityReportRequest = { from, to };
  const { data } = await client(true, true).post<EnqueueAiVisibilityReportResult>(
    `${ENDPOINT}/${projectId}/generate`,
    body
  );
  return data;
};

export const deleteAiVisibilityRun = async (runId: number): Promise<void> => {
  await client(true, true).delete(`${ENDPOINT}/runs/${runId}`);
};

export const deleteAiVisibilityReport = async (reportId: number): Promise<void> => {
  await client(true, true).delete(`${ENDPOINT}/${reportId}`);
};

export const downloadAiVisibilityReport = async (reportId: number): Promise<Blob> => {
  const { data } = await client(true, true).get<Blob>(`${ENDPOINT}/${reportId}/download`, {
    responseType: 'blob',
  });
  return data;
};
